import { HTTP } from "./http";

export const getEmailLogs = (url = false) => new Promise((resolve, reject) => HTTP.get(url || `/email-logs`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getEmailLogById = (id) => new Promise((resolve, reject) => HTTP.get(`/email-logs/${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getEmailActivity = (id, url = false) => new Promise((resolve, reject) => HTTP.get(url || `/email-logs/${id}/activity`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/emails.js